import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { useTranslation } from 'react-i18next';

export const TabAdminUsers = () => {
  const { t } = useTranslation(ENUM__i18n_namespace.SETTINGS_USER);

  return (
    <div className="flex flex-col justify-start items-start mt-2 gap-3  text-page-foreground">
      <span className="text-xl"></span>
    </div>
  );
};
